<template>
  <div class="lg:flex md:grid grid-cols-3 items-center flex-wrap defaultnav">
    <!-- <PostarequirePopup
      :isActive="isDetailsActive"
      :selectedpostrequirement="selectedpostrequirement"
      @close="toggleDetails"
    /> -->
    <!-- <Becomeavolunteer
      :isActive="isvolunteerDetails"
      :selectedvolunteer="selectedvolunteer"
      @close="volunteerDetails"
    /> -->
    <div
      class="py-1 lg:mb-0 md:mb-0 mb-1 cursor-pointer"
      :class="{
        'navlink-active': currentRoute === item.route,
        'md:px-3 lg:px-3 px-2': !item.hasSubmenu,
      }"
      v-for="(item, index) in navitems"
      :key="'item-' + index"
    >
      <b-dropdown
        id="dropdown-offset"
        :text="item.text"
        class="cust-bg-btn cust-p-0 fsize14"
        v-if="item.hasSubmenu"
      >
        <b-dropdown-item
          @click.stop="handleClick(sub)"
          v-for="(sub, index2) in item.submenu"
          :key="'sub-' + index + '-' + index2"
          class="font-semibold fsize14 hovercolor-dd dropdowntext"
          ><div class="flex justify-between items-center">
            {{ sub.text }}
            <feather-icon
              v-if="Object.keys(user).length === 0 ? true : false"
              :icon="sub.icon"
              class="cursor-pointer"
              svgClasses="w-4"
            ></feather-icon></div
        ></b-dropdown-item>
        <b-dropdown-item
          @click="handleletter"
          class="font-semibold fsize14 hovercolor-dd dropdowntext"
          v-show="item.text === 'Insights'"
        >
          Newsletter
        </b-dropdown-item>
        <b-dropdown-item
          @click="handleImpact"
          class="font-semibold fsize14 hovercolor-dd dropdowntext"
          v-show="item.text === 'Insights'"
        >
          Our Impact Report
        </b-dropdown-item>
      </b-dropdown>

      <p
        class="font-semibold fsize16 hovercolor"
        v-else-if="item.route == 'post a requirement'"
        @click="toggleDetails(true, item)"
      >
        {{ item.text }}
      </p>
      <p
        class="font-semibold fsize16 hovercolor"
        v-else-if="item.route == 'become a service provider'"
        @click="volunteerDetails(true, item)"
      >
        {{ item.text }}
      </p>
      <p
        class="font-semibold fsize16 hovercolor"
        @click="handleClick(item)"
        v-else
      >
        {{ item.text }}
      </p>
    </div>
  </div>
</template>

<script>
import PostarequirePopup from "./cg-postarequirePopup.vue";
import Becomeavolunteer from "./cg-becomevolunteerPopup.vue";
// import swal from "sweetalert2";
// import Vue from "vue";

// import VueSweetalert2 from "vue-sweetalert2";
// import "sweetalert2/dist/sweetalert2.min.css";

// Vue.use(VueSweetalert2);

import { mapState } from "vuex";
export default {
  components: {
    PostarequirePopup,
    Becomeavolunteer,
  },
  data() {
    return {
      // currentRoute: "",
      selectedpostrequirement: {},
      selectedvolunteer: {},

      isvolunteerDetails: false,
      isDetailsActive: false,
    };
  },

  props: {
    navitems: {
      type: Array,
      default: () => [
        {
          text: "Caregiver1",
          route: "caregiver",
        },
        {
          text: "Well-wisher",
          route: "wellwisher",
        },
        {
          text: "Healthcare Professionals",
          route: "hcp",
        },
        {
          text: "Corporate",
          route: "corporate",
        },
        {
          text: "Product",
          route: "product",
        },
      ],
    },
  },
  watch: {
    isLoggedin(val) {
      // console.log(val);
    },
  },

  computed: {
    currentRoute() {
      return this.$route.name;
    },
    // ...mapState("auth", {
    //   userData: "userData",
    // }),
    ...mapState("auth", { user: "user" }),
  },
  methods: {
    handleletter() {
      window.open(
        "https://www.linkedin.com/newsletters/caregiver-saathi-6955744421082542080/"
      );
    },
    handleImpact() {
      window.open(
        "https://nimbuscluster.blob.core.windows.net/server01/caregiversaathi/all-in-one/Impact%20Report%202021v%201.0.pdf"
      );
    },
    handleClick(item) {
      // console.log("item111", item);
      // console.log("tabdata222", tabdata);

      // const restrictedItems = [
      //   { text: "Request for Service", route: "request-form" },
      //   {
      //     text: "Corporate Services/ Partnership",
      //     route: "request-form",
      //   },
      //   { text: "Partner With Us", route: "request-form" },
      //   { text: "Work at CGS", route: "request-form" },
      //   {
      //     text: "Share your Story/ Expertise with us",
      //     route: "request-form",
      //   },
      //   { text: "Register for Events", route: "request-form" },
      //   { text: "Register for Programmes", route: "request-form" },
      // ];

      // if (tabdata) {
      //   if (tabdata.text === "Explore") {
      //     const isRestricted = restrictedItems.some(
      //       (restrictedItem) =>
      //         restrictedItem.text === item.text &&
      //         restrictedItem.route === item.route
      //     );

      //     if (isRestricted && !this.user._id) {
      //       this.$swal
      //         .fire({
      //           title: "Access Restricted",
      //           text: "This feature is available for registered users only.",
      //           icon: "warning",
      //           showCancelButton: true,
      //           confirmButtonColor: "#830c81",
      //           confirmButtonText: "Login",
      //           cancelButtonColor: "#830c81",
      //           cancelButtonText: "Register",
      //           customClass: {
      //             confirmButton: ".custom-confirm-button",
      //             cancelButton: ".custom-cancel-button",
      //           },
      //         })
      //         .then((result) => {
      //           console.log("result", result);

      //           if (result.isConfirmed) {
      //             this.$router.push({ name: "signin" });
      //           } else if (result.dismiss === this.$swal.DismissReason.cancel) {
      //             this.$router.push({ name: "register" });
      //           }
      //         });
      //       return;
      //     }
      //   }
      // }

      if (item.route === "request-form") {
        setTimeout(() => {
          this.$router.push({
            name: item.route,
            params: { pathName: item.path },
          });
        }, 10);
      }

      if (item.text === "Testimonial") {
        this.$store.commit("testimonial/REDIRECT_TESTIMONIAL", true);
      }

      this.$router.push({ name: item.route });
      this.$emit("close");
    },

    toggleDetails(val = false, item = {}) {
      this.isDetailsActive = val;
      this.selectedpostrequirement = item;
      this.$router.push({
        name: "request-form",
        params: { pathName: "request-for-service" },
      });
    },

    async volunteerDetails(val = false, item = {}) {
      this.isvolunteerDetails = val;
      this.selectedvolunteer = item;
      this.$router.push({
        name: "request-form",
        params: { pathName: "work-at-cgs-as-volunteer" },
      });
      // let data = await this.$store.dispatch(
      //   "respitecare/get_volunteerbyuserid",
      //   {
      //     volunteerId: this.user._id,
      //     isReq: 1,
      //   }
      // );
      // console.log(val);
      // if (data.data.length > 0) {
      //   this.$swal.fire({
      //     text: "Request for approval has already been sent.",
      //     icon: "success",
      //     confirmButtonText: "Okay",
      //     confirmButtonColor: "#830c81",
      //     showCancelButton: false,
      //   });
      // } else {
      // this.isvolunteerDetails = val;
      // this.selectedvolunteer = item;
      // }
    },
  },
  // computed: {
  //   ...mapState("auth", { user: "user" }),
  //   isLoggedIn() {
  //     if (this.user && this.user._id != null) {
  //       this.isLoggedin = true;
  //     } else {
  //       this.isLoggedin = false;
  //     }
  //     // return this.user && this.user._id != null;
  //   },
};
</script>
<style>
/* .swal2-styled.swal2-confirm {
  font-size: 14px !important;
}
.swal2-styled.swal2-cancel {
  font-size: 14px !important;
} */
</style>
